module.exports = __webpack_public_path__ + "assets/img/32_533_big.c3d41040.jpg";